export enum CrmOpportunityStage {
	AwaitingRfq = 0,
	Quoting = 10,
	Quoted = 20,
	NeedsChasing = 25,
	Chased = 27,
	Negotiation = 30,
	ClosedWon = 40,
	ClosedLost = 50,
	OnHold = 60,
}
